import React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
var SuccessScreen = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, className = _a.className;
    return (React.createElement("div", { className: "lfc-flex lfc-justify-center lfc-items-center lfc-h-full ".concat(className) },
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-items-center lfc-gap-y-4" },
            React.createElement("img", { width: 160, height: 160, src: 'https://ik.imagekit.io/onsnhxjshmp/geebee-emails/VAS/Success%20(2)_AdfdATl7j.gif?updatedAt=1703778274029', alt: title }),
            React.createElement(GBTypography, { variant: "h2", className: "lfc-text-success-500" }, title),
            subTitle && (React.createElement(GBTypography, { variant: "body4", className: "lfc-text-gray-800" }, subTitle)))));
};
export default SuccessScreen;
//# sourceMappingURL=SuccessScreen.js.map